import { render, staticRenderFns } from "./WikiWidget.vue?vue&type=template&id=7aa2e512&scoped=true"
import script from "./WikiWidget.vue?vue&type=script&lang=js"
export * from "./WikiWidget.vue?vue&type=script&lang=js"
import style0 from "./WikiWidget.vue?vue&type=style&index=0&id=7aa2e512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa2e512",
  null
  
)

export default component.exports